export enum TaskNames {
    manueleControleDubbeleRegistratie = 'ManueleControleDubbeleRegistratieTask'
}